import ModalPanel from '@admin/components/modal_panel'
import Message from '@admin/components/message'
import Button from '@admin/components/button'
import PropTypes from 'prop-types'
import React from 'react'

class Complete extends React.Component {

  static propTypes = {
    data: PropTypes.object,
    onDone: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Message { ...this._getMessage() } />
      </ModalPanel>
    )
  }

  _getPanel() {
    return {
      title: 't(Join Affiliate Program)'
    }
  }

  _getMessage() {
    return {
      title: 't(Done!)',
      text: (
        <>
          <p>Thank you for joining the affiliate program</p>
          <p>Here is a link to your new affiliate signup page. Give this link to any referrals you have.</p>
          <p><Button { ...this._getSignupPage() } /></p>. 
        </>
      ),
      svg: 'check',
      color: 'green',
      animation: 'tada',
      button: {
        label: 't(Finish)',
        handler: this._handleDone
      }
    }
  }

  _getSignupPage() {
    const { data } = this.props
    return {
      label: data.shortlink.expanded_url,
      className: 'link',
      link: data.shortlink.expanded_url
    }
  }

  _handleDone() {
    this.props.onDone()
  }

}

export default Complete
